#import "./userInfo.gql"

query GetUsers {
  users {
    ...userInfo
  }
}

query GetUser($id: ID!) {
  user(id: $id) {
    ...userInfo
  }
}

mutation CreateUser(
  $id: ID!
  $companyId: ID
  $email: String!
  $password: String!
  $role: String!
  $allowedSiteIds: [ID!]
) {
  createUser(
    id: $id
    companyId: $companyId
    email: $email
    password: $password
    role: $role
    allowedSiteIds: $allowedSiteIds
  ) {
    user {
      ...userInfo
    }
  }
}

mutation UpdateUser($companyId: ID, $id: ID!, $role: String!, $allowedSiteIds: [ID!]) {
  updateUser(companyId: $companyId, id: $id, role: $role, allowedSiteIds: $allowedSiteIds) {
    user {
      ...userInfo
    }
  }
}

mutation DeleteUser($id: ID!) {
  deleteUser(id: $id) {
    email
  }
}
